var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.loading)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading_img",attrs:{"src":require("@/assets/images/Loading.gif"),"alt":"Carregando..."}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }